import { forEach, remove } from "lodash";

import { ONE_HOUR_PX, COLOR_DEFAULT } from "../../constants";

const defaultColor = COLOR_DEFAULT;

export const getDriverIds = (routes, driverIdsT, driverId) => {
  const driverIds = [...driverIdsT];
  if (driverIds.includes(driverId)) {
    remove(driverIds, item => item === driverId);
    if (driverId === "all-drivers") {
      remove(driverIds, item => item !== "unassigned");
    } else if (driverId !== "unassigned" && driverIds.includes("all-drivers")) {
      remove(driverIds, item => item === "all-drivers");
    }
  } else {
    driverIds.push(driverId);
    if (driverId === "all-drivers") {
      forEach(routes, route => driverIds.push(route.driver._id));
    } else if (driverIds.filter(d => d !== "unassigned").length === routes?.length) {
      driverIds.push("all-drivers");
    }
  }
  return driverIds;
};

export const convertToInt = time => {
  if (!time) return -1;
  const times = time.split(":");
  return parseInt(times[0]) * 60 + parseInt(times[1]);
};

export const getListStyle = (dragging, focus, disabled) => {
  const style = {};
  if (dragging) {
    style.border = "1px dashed #b5b5b5";
  }
  if (focus) {
    style.border = "1px dashed #212121";
  }
  if (disabled) {
    style.border = "none";
    style.cursor = "no-drop";
  }
  return style;
};

export const getStopsHash = stops => {
  const stopsHash = {};
  forEach(stops, stop => {
    stopsHash[stop.id] = stop;
  });
  return stopsHash;
};

export const getActionDnd = (history, solutions, index) => {
  if (history.currentIndex === index) {
    return "none";
  } else {
    const ids = Object.keys(solutions);
    const assign = ids.find(id => id.includes("assign_") && solutions[id].length > 0);
    if (assign) return "optimize";
  }
  return "sort";
};

export const getActiveAction = (action, history) => {
  let pointToVersion = history.currentIndex;
  let active = false;
  switch (action) {
    case "undo":
      pointToVersion = history.currentIndex - 1;
      if (pointToVersion >= 0) {
        active = true;
      }
      break;
    case "redo":
      pointToVersion = history.currentIndex + 1;
      if (pointToVersion < history?.listSolutions.length) {
        active = true;
      }
      break;
    case "revert":
      pointToVersion = 0;
      active = true;
      break;
  }
  return { active, pointToVersion };
};

export const isDiffTwoArrayStops = (arr1 = [], arr2 = []) => {
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i]?._id !== arr2[i]?._id) return true;
  }
  if (arr1.length !== arr2.length) return true;
  return false;
};

export const getWidthChart = (start, end, one_hour_px = ONE_HOUR_PX) => {
  const duration = durationMinutes(start, end);
  return convertMinutesToPixel(duration, one_hour_px);
};

export const calculatePixelBetweenStops = (stops, route, one_hour_px = ONE_HOUR_PX) => {
  if (stops.length === 0) return stops;
  let tmpStop = stops[0];
  const returnStops = stops.map((stop, index) => {
    if (index === 0) {
      const width = getWidthChart(route.shiftStart, stop.arrivalTime, one_hour_px);
      tmpStop = stop;
      return {
        ...stop,
        color: `#${route.driver.color || defaultColor}`,
        index,
        marginLeft: width,
      };
    }
    const width = getWidthChart(tmpStop.finishTime, stop.arrivalTime, one_hour_px);
    tmpStop = stop;
    return {
      ...stop,
      color: `#${route.driver.color || defaultColor}`,
      index,
      marginLeft: width,
    };
  });
  return returnStops;
};

export const convertMinutesToPixel = (minutes, one_hour_px = ONE_HOUR_PX) => {
  // 1 hour = 98px =>  60 minutes = 98px
  if (minutes === 0) return 0;
  return (minutes * one_hour_px) / 60;
};

export const convertPixelToMinutes = (pixels, one_hour_px = ONE_HOUR_PX) => {
  if (pixels === 0) return 0;
  return (pixels * 60) / one_hour_px;
};

export const sortBy = (field, reverse, primer) => {
  const key = primer
    ? function (x) {
        return primer(x[field]);
      }
    : function (x) {
        return x[field];
      };

  reverse = !reverse ? 1 : -1;

  return function (a, b) {
    return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
  };
};

export const convertToMinutes = time => {
  if (!time) return 0;
  const timeSplit = time.split(":");
  const hour = timeSplit[0];
  const minute = timeSplit[1];
  return parseInt(hour) * 60 + parseInt(minute);
};
export const getFirstStartAndLastEnd = routes => {
  if (routes.length === 0) return [0, 0];

  const firstRoute = routes[0];
  let returnStart = firstRoute.shiftStart ?? "00:00";
  let returnEnd = firstRoute.shiftEnd;
  let firstStart = convertToMinutes(returnStart);
  let lastEnd = convertToMinutes(returnEnd);

  forEach(routes, route => {
    const shiftStart = route.shiftStart ?? "00:00";
    const minuteStartAt = convertToMinutes(shiftStart);
    const minuteEndAt = convertToMinutes(route.shiftEnd);
    if (minuteStartAt < firstStart) {
      returnStart = shiftStart;
      firstStart = minuteStartAt;
    }

    if (lastEnd < minuteEndAt) {
      returnEnd = route.shiftEnd;
      lastEnd = minuteStartAt;
    }
  });
  return [returnStart, returnEnd];
};

export const durationMinutes = (start, end) => {
  if (!start || !end) return 0;
  return convertToMinutes(end) - convertToMinutes(start);
};
